export const winnerCards = [
  {
    id: 'winner-2024',
    span: 'normal',
    year: '2024',
    media: 'Film | Video',
    name: 'HeeHyun Choi',
    image: '/uploads/2024/06/winner-2024-3.png',
    portrait: '/uploads/2016/11/Frame-1.jpg',
    href: '/archives/portfolio-item/heehyun-choi',
  },
  {
    id: 'winner-2022',
    span: 'normal',
    year: '2022',
    media: 'Social Practice and Autoethnography',
    name: 'Mirae Kh Rhee',
    image: '/uploads/2022/07/RHEE_kate-hers_PORTFOLIO-3.jpg',
    portrait: '/uploads/2022/07/kate-hers-RHEE.jpg',
    href: '/archives/portfolio-item/mirae-kh-rhee',
  },
  {
    id: 'winner-2020',
    span: 'wide',
    year: '2020',
    media: 'Photography | Sculpture | Video',
    name: 'Young Joon Kwak',
    image: '/uploads/2020/05/RVD8644.jpg',
    portrait: '/uploads/2020/05/YJK_headshot.jpg',
    href: '/archives/portfolio-item/young-joon-kwak',
  },
  {
    id: 'winner-2018',
    span: 'normal',
    year: '2018',
    media: 'Sculpture',
    name: 'Robert Rhee',
    image: '/uploads/2018/06/01-Good-For-Web.jpg',
    portrait: '/uploads/2020/04/RobertRhee.jpg',
    href: '/archives/portfolio-item/robert-rhee',
  },
  {
    id: 'winner-2016',
    span: 'normal',
    year: '2016',
    media: 'Installation | Performance | Sculpture',
    name: 'Jennifer Moon',
    image: '/uploads/2015/08/jmoon7.jpg',
    portrait: '/uploads/2020/04/JenniferMoon.png',
    href: '/archives/portfolio-item/jennifer-moon',
  },
  {
    id: 'winner-2014',
    span: 'normal',
    year: '2014',
    media: 'Installation | Sculpture',
    name: 'Olga Lah',
    image: '/uploads/2016/11/olga2.jpg',
    portrait: '/uploads/2020/04/OlgaLah.jpg',
    href: '/archives/portfolio-item/olga-lah',
  },
  {
    id: 'winner-2012',
    span: 'normal',
    year: '2012',
    media: 'Installation | Sculpture',
    name: 'Jean Shin',
    image: '/uploads/2016/11/jeanshin1.jpg',
    portrait: '/uploads/2020/04/JeanShin.jpg',
    href: '/archives/portfolio-item/jean-shin',
  },
  {
    id: 'winner-2010',
    span: 'wide',
    year: '2010',
    media: 'Drawing | Painting',
    name: 'Kakyoung Lee',
    image: '/uploads/2016/11/kakyoung_lee_8_walk-2010_2-big_1280x839.jpg',
    portrait: '/uploads/2020/04/KakyoungLee.jpg',
    href: '/archives/portfolio-item/kakyoung-lee',
  },
  {
    id: 'winner-2008',
    span: 'normal',
    year: '2008',
    media: 'Performance | Photography | Video',
    name: 'Jaye Rhee',
    image: '/uploads/2016/11/jaye-rheeinstallation.jpg',
    portrait: '/uploads/2020/04/JayeRhee.jpg',
    href: '/archives/portfolio-item/jaye-rhee',
  },
  {
    id: 'winner-2006',
    span: 'normal',
    year: '2006',
    media: 'Installation | Sculpture',
    name: 'Won Ju Lim',
    image: '/uploads/2016/11/install_1_1600x1076.jpg',
    portrait: '/uploads/2020/04/WonJuLim.jpg',
    href: '/archives/portfolio-item/won-ju-lim',
  },
  {
    id: 'winner-2004',
    span: 'normal',
    year: '2004',
    media: 'Drawing | Painting | Installation',
    name: 'Jena H. Kim',
    image: '/uploads/2016/11/jena-h-kim-1280x857-1.jpg',
    portrait: '/uploads/2020/04/JenaHKim.jpg',
    href: '/archives/portfolio-item/jena-h-kim',
  },
  {
    id: 'winner-2002',
    span: 'normal',
    year: '2002',
    media: 'Drawing | Painting',
    name: 'Maria Park',
    image: '/uploads/2016/11/mariapark2.jpg',
    portrait: '/uploads/2020/04/MariaPark.jpg',
    href: '/archives/portfolio-item/maria-park',
  },
  {
    id: 'winner-2000',
    span: 'normal',
    year: '2000',
    media: 'Sculpture',
    name: 'Jyung Mee Park',
    image: '/uploads/2016/11/jyungmee_park_862x1280.jpg',
    portrait: '/uploads/2020/04/JyungMeePark.jpg',
    href: '/archives/portfolio-item/jyung-mee-park',
  },
  {
    id: 'winner-1998',
    span: 'normal',
    year: '1998',
    media: 'Drawing | Painting | Installation | Sculpture',
    name: 'Do-Ho Suh',
    image: '/uploads/2016/11/Do-ho-suh_1280x847.jpg',
    portrait: '/uploads/2020/04/DoHoSuh.jpg',
    href: '/archives/portfolio-item/do-ho-suh',
  },
  {
    id: 'winner-1996',
    span: 'normal',
    year: '1996',
    media: 'Sculpture',
    name: 'Yunhee Min',
    image: '/uploads/2016/11/yunhee2.jpg',
    portrait: '/uploads/2020/04/YunHeeMin.jpg',
    href: '/archives/portfolio-item/yunhee-min',
  },
  {
    id: 'winner-1995',
    span: 'normal',
    year: '1995',
    media: 'Drawing | Painting',
    name: 'Alice Park-Spurr',
    image: '/uploads/2016/11/Alice_park_spurrClose-to-Heaven.jpg',
    portrait: '/uploads/2020/04/AliceParkSpurr.jpg',
    href: '/archives/portfolio-item/alice-park-spurr',
  },
  {
    id: 'winner-1994',
    span: 'normal',
    year: '1994',
    media: 'Drawing | Painting | Sculpture',
    name: 'Byron Kim',
    image: '/uploads/2016/11/byron2.jpg',
    portrait: '/uploads/2020/04/ByronKim.jpg',
    href: '/archives/portfolio-item/byron-kim',
  },
  {
    id: 'winner-1993',
    span: 'normal',
    year: '1993',
    media: 'Drawing | Painting | Installation | Photography | Sculpture',
    name: 'Sook Jin Jo',
    image: '/uploads/2016/11/sookjin6.jpg',
    portrait: '/uploads/2020/04/SookJinJo.jpg',
    href: '/archives/portfolio-item/sook-jin-jo',
  },
  {
    id: 'winner-1992',
    span: 'normal',
    year: '1992',
    media: 'Sculpture',
    name: 'Yun-Dong Nam',
    image: '/uploads/2016/11/yundongnam2.jpg',
    portrait: '/uploads/2020/04/YunDongNam.jpg',
    href: '/archives/portfolio-item/yun-dong-nam',
  },
];
